import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { userNeedsTransactionPin } from '../../utils/auth/permissionConstants';

const PermissionGate = ({
    requiredRoleSlug,
    requiredPermissionSlug,
    requiresUserWallet,
    requiresPartnerVault,
    requiresPartner,
    requiresTransactionPin,
    children,
}) => {
    const authUser = useSelector((state) => state.auth.authUser);
    const userRole = authUser?.role_slug;
    const permissionSlugs = authUser?.all_permission_slugs ?? [];
    const hasActiveWallet = authUser?.has_active_wallet;
    const hasActivePartnerVault = authUser?.has_active_partner_vault;
    const hasTransactionPin = authUser?.has_transaction_pin;
    const partner = authUser?.partner;
    const location = useLocation();

    if (requiredRoleSlug && userRole !== requiredRoleSlug) return <Navigate to="/page-error-403" replace />;
    if (requiredPermissionSlug && !permissionSlugs.includes(requiredPermissionSlug)) return <Navigate to="/page-error-403" replace />;
    if (requiresUserWallet && !hasActiveWallet) return <Navigate to="/page-error-403" replace />;
    if (requiresPartnerVault && !hasActivePartnerVault) return <Navigate to="/page-error-403" replace />;
    if (requiresPartner && !partner) return <Navigate to="/page-error-403" replace />;

    // Anyone the app will ask for a transaction PIN (a wallet holder for
    // their own payouts, or a top-up caller moving money into other people's
    // wallets) must set one before entering a PIN-guarded surface. The
    // redirect preserves the originally-requested path so setting the PIN
    // brings them back.
    if (requiresTransactionPin && userNeedsTransactionPin(authUser) && hasTransactionPin === false) {
        const redirectTarget = `${location.pathname}${location.search}`;
        return <Navigate to={`/set-transaction-pin?redirect=${encodeURIComponent(redirectTarget)}`} replace />;
    }

    return children;
};

export default PermissionGate;
